// @file Vuex Store module for filtering posts in a wall.
import { SurfaceFilter } from 'enums'
import type { Module } from 'vuex'
import type { PostFilterState, RootState } from 'vuexstore/surface/types'

const postFilter: Module<PostFilterState, RootState> = {
  namespaced: true,
  state: {
    filter: SurfaceFilter.All,
    xFilterPopover: false,
  },
  getters: {
    filter: (state: PostFilterState): SurfaceFilter => state.filter,
    isCustomFilter: (state: PostFilterState): boolean => state.filter !== SurfaceFilter.All,
    xFilterPopover: (state: PostFilterState): boolean => state.xFilterPopover,
  },
  mutations: {
    SET_FILTER(state: PostFilterState, filter: SurfaceFilter): void {
      state.filter = filter
    },
    SHOW_FILTER_POPOVER(state: PostFilterState): void {
      state.xFilterPopover = true
    },
    HIDE_FILTER_POPOVER(state: PostFilterState): void {
      state.xFilterPopover = false
    },
  },
  actions: {
    setFilter({ commit }, filter: SurfaceFilter): void {
      commit('SET_FILTER', filter)
    },
    showFilterPopover({ commit }): void {
      commit('SHOW_FILTER_POPOVER')
    },
    hideFilterPopover({ commit }): void {
      commit('HIDE_FILTER_POPOVER')
    },
  },
}

export default postFilter
